/*
 *
 * AmlPopup
 *
 * @version 1.0.0
 * @author Minozzi Elia
 * @since 30-Giu-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  amlTitle: <PortalMessage
    id='t.app.ttl.aml.title'
    defaultMessage='Normativa antiriciclaggio'
            />,
  amlTitleBlocked: <PortalMessage
    id='t.app.aml.amlTitleBlocked'
    defaultMessage='Operatività sospesa (normativa antiriciclaggio)'
                   />,
  amlTitlePersonalDataUndefined: <PortalMessage
    id='t.app.aml.amlTitlePersonalDataUndefined'
    defaultMessage='Dati in elaborazione (normativa antiriciclaggio)'
                                 />,
  amlTitleDataNonPresent: <PortalMessage
    id='t.app.aml.amlTitleDataNonPresent'
    defaultMessage='Dati incompleti (normativa antiriciclaggio)'
                          />,
  amlPopUpDescription: <PortalMessage
    id='t.app.aml.amlPopUpDescription'
    defaultMessage='A fronte del recepimento delle novità introdotte dalle nuove disposizioni europee in materia di adeguata verifica della clientela per il contrasto al riciclaggio e finanziamento del terrorismo, Nexi ha l’obbligo di raccogliere dalla propria clientela ulteriori informazioni necessarie a garantire la corretta identificazione del cliente, dell’eventuale esecutore e del/gli eventuale/i titolare/i effetivo/i. Si ricorda che il rilascio delle informazioni avviene sotto la responsabilità del cliente stesso (ex art. 22 D.Lgs. 231/2007).'
                       />,
  amlPopUpDescriptionNotCompliantBlocked: <PortalMessage
    id='t.app.aml.amlPopUpDescriptionNotCompliantBlocked'
    defaultMessage='Per poter accedere a tutte le funzionalità di Nexi Business è necessario compilare le informazioni relative alla normativa antiriciclaggio.'
                                          />,
  amlPopUpDescriptionPersonalDataUndefined: <PortalMessage
    id='t.app.aml.amlPopUpDescriptionPersonalDataUndefined'
    defaultMessage='Stiamo elaborando i tuoi dati. Per il momento non è possibile accedere al questionario sulla normativa antiriciclaggio. Riprova tra qualche giorno.'
                                            />,
  amlPopUpDescriptionBlockedUpdating: <PortalMessage
    id='t.app.aml.amlPopUpDescriptionBlockedUpdating'
    defaultMessage='Stiamo elaborando i tuoi dati. Per il momento non è possibile navigare su Nexi Business. Riprova tra qualche giorno.'
                                      />,
  amlPopUpDescriptionDataNonPresent: <PortalMessage
    id='t.app.aml.amlPopUpDescriptionDataNonPresent'
    defaultMessage='Per integrare le informazioni non presenti nella nostra anagrafica, ti invitiamo a inviare i seguenti documenti all’indirizzo email <strong>archivi.esercenti@nexi.it</strong>: {ul}{li}codice fiscale o carta d’identità del legale rappresentante e di eventuali titolari effettivi{/li}{li}visura camerale{/li}{/ul}'
    values={{
      ul: (chunks) => <ul>{chunks}</ul>,
      '/ul': '',
      li: (chunks) => <li>{chunks}</li>,
      '/li': ''
    }}
                                     />,
  amlPopUpDescriptionAdminNonCompliant: <PortalMessage
    id='t.app.aml.amlPopUpDescriptionAdminNonCompliant'
    defaultMessage='Ricorda che il tuo amministratore è tenuto a compilare le informazioni richieste dalla nuova normativa antiriciclaggio, in modo da non far sospendere la tua utenza. <br/> <br/> Contatta il tuo amministratore per non perdere l’accesso a tutte le funzionalità Nexi Business.'
                                        />,
  amlPopUpDescriptionAdminBlocked: <PortalMessage
    id='t.app.aml.amlPopUpDescriptionAdminBlocked'
    defaultMessage='Contatta il tuo amministratore per poter accedere a tutte le funzionalità di Nexi Business.'
                                   />,
  view: <PortalMessage
    id='t.app.view'
    defaultMessage='Visualizza'
        />,
  exit: <PortalMessage
    id='t.app.logout'
    defaultMessage='Esci'
        />,
  okUnderstood: <PortalMessage
    id='t.app.okUnderstood'
    defaultMessage='Ok, ho capito'
                />,
  goToSurvey: <PortalMessage
    id='t.app.aml.goToSurvey'
    defaultMessage='Vai al questionario'
              />
}

export default formattedMessage
